import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Stack,
  Fade,
} from '@mui/material';
import { Balance, Favorite, WbSunny, Nature } from '@mui/icons-material';

const philosophies = [
  {
    icon: Balance,
    title: 'Balance',
    description: 'We believe in the harmony of mind, body, and spirit. True wellness emerges when all aspects of your being are in equilibrium.',
  },
  {
    icon: Favorite,
    title: 'Compassion',
    description: 'Every individual is unique. We approach each person with deep care, understanding, and personalized attention.',
  },
  {
    icon: WbSunny,
    title: 'Vitality',
    description: 'Health is not merely the absence of disease, but a vibrant state of complete physical, mental, and social well-being.',
  },
  {
    icon: Nature,
    title: 'Nature',
    description: 'We honor the healing power of nature, using organic remedies and sustainable practices in all our treatments.',
  },
];

const PhilosophySection = () => {
  return (
    <Box
      id="philosophy"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'background.paper',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Fade in timeout={1000}>
          <Stack spacing={6}>
            {/* Section Header */}
            <Stack spacing={2} alignItems="center">
              <Typography
                variant="overline"
                sx={{
                  color: 'primary.main',
                  fontWeight: 600,
                  letterSpacing: '0.2em',
                }}
              >
                Principles
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '3rem' },
                  fontWeight: 700,
                  textAlign: 'center',
                }}
              >
                Our Philosophy
              </Typography>
              <Box
                sx={{
                  width: 60,
                  height: 3,
                  bgcolor: 'primary.main',
                  borderRadius: 2,
                }}
              />
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ textAlign: 'center', maxWidth: 700, lineHeight: 1.8 }}
              >
                Our philosophy is rooted in the ancient wisdom of Ayurveda, which teaches
                that health is a state of balance between body, mind, and consciousness.
                We integrate this timeless knowledge with modern wellness practices.
              </Typography>
            </Stack>

            {/* Philosophy Grid */}
            <Grid container spacing={4} className='grid-w mt-20'>
              {philosophies.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <Grid item xs={12} sm={6} md={3} key={index} className='grid-cst'>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 4,
                        height: '100%',
                        borderRadius: 3,
                        textAlign: 'center',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-8px)',
                          boxShadow: 6,
                        },
                      }}
                    >
                      <Stack spacing={2} alignItems="center">
                        <Box
                        className="icon-circle2"
                          sx={{
                            width: 70,
                            height: 70,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <IconComponent sx={{ color: 'white', fontSize: 36 }} />
                        </Box>
                        <Typography variant="h5" fontWeight={600}>
                          {item.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                          {item.description}
                        </Typography>
                      </Stack>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Stack>
        </Fade>
      </Container>
    </Box>
  );
};

export default PhilosophySection;
